import { debounce } from 'lodash';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollRestoration = () => {
  const location = useLocation();

  useEffect(() => {
    const savedScrollPosition = sessionStorage.getItem(
      `scrollPosition-${location.pathname}`
    );
    if (savedScrollPosition) {
      window.scrollTo({
        top: parseInt(savedScrollPosition, 10),
        behavior: 'instant'
      });
    }

    const handleScroll = () => {
      sessionStorage.setItem(
        `scrollPosition-${location.pathname}`,
        window.scrollY
      );
    };

    const debouncedHandleScroll = debounce(handleScroll, 600);

    window.addEventListener('wheel', debouncedHandleScroll);
    return () => {
      window.removeEventListener('wheel', debouncedHandleScroll);
      debouncedHandleScroll.cancel();
    };
  }, [location.pathname]);
};

export default useScrollRestoration;
